module.exports = __webpack_public_path__ + "img/3.1db5b2d0.png";